<template>
<el-dialog title="用户信息" :visible.sync="dialogVisible" width="80%">
  <div class="show">
    <el-tabs v-model="activeName" v-loading="loading">
      <el-tab-pane label="用户个人信息" name="first">
        <el-form :disabled="true" :inline="true" ref="formEdit" class="demo-form-inline">
          <div class="top">
            <div class="item">
              <p>用户名</p>
              <div>
                <el-input v-model="change.username" placeholder="请输入用户名" clearable></el-input>
              </div>
            </div>
            <div class="item">
              <p>联系方式</p>
              <div>
                <el-input v-model="change.telephone" placeholder="请输入用户联系电话" clearable></el-input>
              </div>
            </div>
            <div class="item">
              <p>密码</p>
              <div>
                <el-input v-model="change.password" placeholder="请输入默认密码" clearable></el-input>
              </div>
            </div>
            <div class="item">
              <p>邮箱</p>
              <div>
                <el-input v-model="change.email" placeholder="请输入用户邮箱" clearable></el-input>
              </div>
            </div>
          </div>
          <div class="bu">

            <div class="item">
              <p>可导个数</p>
              <div>
                <el-input v-model="change.derivedNumber" placeholder="请输入用户可导出案例个数" clearable></el-input>
              </div>
            </div>
            <div class="item">
              <p>性别</p>
              <div>
                <el-input v-model="change.gender" placeholder="性别" clearable></el-input>
              </div>
            </div>
            <div class="item">
              <p>用户类型</p>
              <div>
                <el-input v-model="change.usertype" placeholder="用户类型" clearable></el-input>
              </div>
            </div>
            <div class="item">
              <p>用户描述</p>
              <div>
                <el-input v-model="change.description" placeholder="用户描述" clearable></el-input>
              </div>
            </div>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane class="tab" label="用户导出案例信息" name="second">
        <div class="caseNumber" v-for="item in caseNumber" :key="item">{{item}}</div>
        <div>
          <div class="footer">
            <el-pagination background layout="total,prev,sizes, pager, next,jumper" :current-page="pageInfo.currentPage" :page-size="pageInfo.pageSize" :total="pageInfo.total" :page-sizes="[30]" @current-change="handleCurrentChange">
            </el-pagination>
          </div>

        </div>

      </el-tab-pane>
    </el-tabs>
  </div>

</el-dialog>
</template>

<script>
import bus from "../statistics/bus";
export default {
  name: "viewUser",
  data() {
    return {
      /*加载动画*/
      loading: false,
      dialogVisible: false,
      activeName: 'first',
      change: {
        id: '',
        username: '',
        password: '',
        telephone: '',
        email: '',
        gender: '',
        description: '',
        derivedNumber: '',
        usertype: ''
      },
      pageInfo: {
        currentPage: 1,
        pageSize: 30,
        total: 0
      },
      caseNumber: [],
    }
  },
  methods: {
    /*分页切换*/
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val;
      this.loading = true;
      this.$http.get('/derivedcase/search', {
        params: {
          searchString: this.change.telephone,
          pageNo: this.pageInfo.currentPage,
          pageSize: 30
        }
      }).then((res) => {
        res.data.forEach((item, index) => {
          this.caseNumber.push(item.caseNumber)
        });
        this.$nextTick(
          this.loading = false,
        );
      }).catch((err) => {
        this.$nextTick(
          this.loading = false,
        );
      })
    },
  },
  mounted() {
    bus.$on('viewUser', (index, rowData) => {
      for (let key of Object.keys(rowData)) {
        if (key === "id" || key === "email" || key === "gender" || key === "usertype" || key === 'telephone' || key === "description" || key === "derivedNumber" || key === "username") {
          this.change[key] = rowData[key];
        }
      }
      this.caseNumber = [];
      this.dialogVisible = true;
      /*发请求*/
      this.loading = true;
      this.$http.get('/derivedcase/search', {
        params: {
          searchString: this.change.telephone,
          pageNo: this.pageInfo.currentPage,
          pageSize: 30
        }
      }).then((res) => {
        this.pageInfo.total = res.totalCount;
        res.data.forEach((item, index) => {
          this.caseNumber.push(item.caseNumber)
        })
        this.$nextTick(
          this.loading = false,
        );
      }).catch((err) => {
        this.$nextTick(
          this.loading = false,
        );
      })
    })
  }
}
</script>

<style scoped>
.show .top,
.show .bu {
  display: flex;
}

.show .top {
  margin-bottom: 10px;
}

.show .item {
  display: flex;
}

.show .item>p {
  width: 60px;
  line-height: 40px;
  margin: 0px 10px;
}

.show .caseNumber {
  width: 15%;
  height: 40px;
  background-color: #E8EAED;
  margin-left: 1%;
  margin-right: 1%;
  margin-top: 5px;
  display: inline-block;
  line-height: 40px;
  text-align: center;
  border-radius: 5px;
  font-size: 18px;
}

.show .tab {
  max-height: 600px;
  overflow: auto;
}

.show .tab .footer {
  margin: 20px auto 0px auto;
  width: 500px;
}
</style>

<style>
.show .el-tabs__nav {
  left: 40.5%;
}
</style>



// WEBPACK FOOTER //
// src/user/viewUser.vue